import {
  SET_FEATURED_INSTAGRAM_POST,
  SET_ABOUT_US_ENTITIES,
  SET_WEB_POPUP,
} from "../actions/generalActions";

const defaultState = {
  featuredInstagramPosts: [],
  aboutUsEntities: [],
  webPopups: [],
};

const reducers = (state = defaultState, action) => {
  switch (action.type) {
    case SET_FEATURED_INSTAGRAM_POST:
      return { ...state, featuredInstagramPosts: action.payload };
    case SET_ABOUT_US_ENTITIES:
      return { ...state, aboutUsEntities: action.payload };
    case SET_WEB_POPUP:
      return { ...state, webPopups: action.payload };
    default:
      return state;
  }
};
export default reducers;
